import React, { useContext } from 'react';
import _ from 'lodash';
import AppContext from '../AppContext';

const withFlow = (WrappedComponent) => {
  const withFlowHOC = (props) => {
    const context = useContext(AppContext);

    const {
      actions: { stepTo, setFlow },
      state: {
        urlParams,
        step: { component, page, pageCount }
      }
    } = context;

    const handleMoveNext = () => {
      const {
        state: { flows }
      } = context;

      const nextFlow = _.find(flows, { curr: component });
      const nextStep = nextFlow.next;
      const prevStep = component;

      const nextPage = nextFlow.nextIncreaseCount ? page + 1 : page;
      stepTo({ component: nextStep, page: nextPage });
    };

    return <WrappedComponent {...props} handleMoveNext={handleMoveNext} />;
  };

  withFlowHOC.displayName = `withFlow(${getDisplayName(WrappedComponent)})`;
  return withFlowHOC;
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default withFlow;
